module.exports = __webpack_public_path__ + "img/banner02.a26a4581.jpg";